import { useId } from "react";
import { AffiliationStatus } from "@api/shared-runtime/enums";
import { RadioGroup, RadioGroupItem } from "@/components/ui/radio-group";
import { Label } from "@/components/ui/label";
import type { NewProviderEmploymentStatus } from "./use-invite-provider-form";

export function ProviderEmploymentField({
  value,
  error,
  disabled,
  onChange,
}: {
  value: NewProviderEmploymentStatus | undefined;
  error: string | null;
  disabled: boolean;
  onChange: (status: NewProviderEmploymentStatus) => void;
}) {
  const id = useId();
  return (
    <fieldset className="space-y-2">
      <legend className="text-sm font-medium">
        Employment status (required)
      </legend>
      <RadioGroup
        value={value ?? ""}
        onValueChange={(status) => {
          if (
            status === AffiliationStatus.Candidate ||
            status === AffiliationStatus.Hired
          ) {
            onChange(status);
          }
        }}
        disabled={disabled}
        aria-label="Employment status"
        aria-required="true"
        aria-invalid={!!error}
        aria-describedby={error ? `${id}-error` : undefined}
        className="grid grid-cols-2 gap-3"
      >
        <Label
          htmlFor={`${id}-candidate`}
          className="flex cursor-pointer items-center gap-2 rounded-md border p-3"
        >
          <RadioGroupItem
            value={AffiliationStatus.Candidate}
            id={`${id}-candidate`}
          />
          Candidate
        </Label>
        <Label
          htmlFor={`${id}-hired`}
          className="flex cursor-pointer items-center gap-2 rounded-md border p-3"
        >
          <RadioGroupItem value={AffiliationStatus.Hired} id={`${id}-hired`} />
          Hired
        </Label>
      </RadioGroup>
      {error && (
        <p
          id={`${id}-error`}
          role="alert"
          className="text-sm font-medium text-destructive"
        >
          {error}
        </p>
      )}
    </fieldset>
  );
}
